import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnDestroy, signal } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { LogList, Payload } from '@models/common.model';
import { Card } from '@services/card.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'lgb-card-index',
  imports: [
    UiModule,
    CommonModule
  ],
  templateUrl: './card-index.html',
  styleUrl: './card-index.css',
})
export class CardIndex implements OnDestroy{
  readonly payloads=signal<Payload[]>([]);
  readonly CardS=inject(Card);
  readonly loading=signal(false);
  readonly error=signal<string>(null);
  readonly msg=signal<string>(null);
  
  //log
  readonly logs: LogList=new LogList();
  readonly logsAsync: LogList=new LogList();
  readonly fullLogs=signal(new LogList());

  private logId: string=null;
  private interval: any;


  constructor(){
    this.logs.add('Indexes pret à être générés...');
    this.updateLogs();
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  getClassState(payload: Payload){
    return {
      'badge-error': payload.state=='Error',
      'badge-success': payload.state=='Valide'
    };
  }

  start(){
    this.payloads().splice(0, this.payloads().length);
    this.logs.empty();
    this.logsAsync.empty();
    this.logs.add('Generation de l\'index...');
    this.replayLoop(0);
  }

  replay(step: number, loop: boolean=false){
    this.updateLogs();
    clearInterval(this.interval);
    if(!this.loading()){
      this.loading.set(true);
      this.error.set(null);
      this.CardS.updateIndex(step)
        .subscribe({
          next: p => {
            this.loading.set(false);
            this.endReplay(p, loop)
          },
          error: e => {
            this.loading.set(false);
            this.error.set(e);
          }
        });
    };
  }

  replayLoop(step: number){
    this.replay(step, true);
  }

  private endReplay(payload: Payload, loop: boolean=false){
    //mise à jour des payloads
    /*this.payloads.update(payloads => {
      const next: Payload[]=[...payloads];
      next.push(payload);
      return next;
    });*/

    this.payloads().push(payload);

    //mise à jour des logs de la console
    this.logs.addWrapLogs(payload.logs);
    this.updateLogs();

    //si loop et next => suivant
    //sinon set loading => false
    if(loop && payload.next)
      this.replay(payload.next, loop);
    else{
      this.logId=payload.datas.log;
      this.watchLog();
      this.loading.set(false);
    }
  }

  watchLog(){
    this.interval=setInterval(() => {
      this.CardS.getIndexLog(this.logId).subscribe(log => {
        this.logsAsync.empty();
        this.logsAsync.add(log.content);
        this.updateLogs();
      });
    }, 10000);
  }

  updateLogs(){
    const next: LogList=new LogList();
    next.addLogList(this.logs);
    next.addLogList(this.logsAsync);
    this.fullLogs.set(next);
  }
}